import { Button, CircularProgress, TextField, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { messageSVC } from "message/service"
import { normalizeSync } from "normalize-diacritics"
import React from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { IUserTag } from "user-tag/model"
import { createUserTag } from "user-tag/tools/common"

interface IUserTagAddProps {
  tags: IUserTag[]
}

const UserTagAddFn = ({ tags }: IUserTagAddProps) => {
  const [newTagName, setNewTagName] = React.useState("")
  const [isCreating, setIsCreating] = React.useState(false)
  const normalizedName = normalizeSync(newTagName).toLowerCase()
  const alreadyExist = tags.findByProperty("normalizedName", normalizedName) !== undefined
  const canAdd = !isCreating && newTagName.trim() !== "" && !alreadyExist
  const createTag = async () => {
    try {
      if (!canAdd) {
        return
      }
      setIsCreating(true)
      await createUserTag(newTagName)
      messageSVC.info(translate("tag.new.created", newTagName))
      setNewTagName("")
      setIsCreating(false)
      document.getElementById("new-tag-field")?.focus()
    } catch (error) {
      console.error(error)
      setIsCreating(false)
      messageSVC.error(translate("tag.creating.error"))
    }
  }
  return (
    <FlexBox vertical ai="start">
      <FlexBox gap wrap>
        <Typography color="textPrimary" fontWeight={500} fontSize=".9rem">
          {translate("tag.add")}
        </Typography>
        <TextField
          id="new-tag-field"
          disabled={isCreating}
          value={newTagName}
          autoFocus
          onChange={event => setNewTagName(event.target.value)}
          size="small"
          onKeyUp={event => {
            event.stopPropagation()
            event.preventDefault()
            if (event.key === "Enter") {
              createTag()
            }
          }}
        />
        <Button
          id="new-tag-button"
          variant="contained"
          onClick={createTag}
          disabled={!canAdd}
          startIcon={isCreating ? <CircularProgress id="tag-is-creating" /> : undefined}>
          {translate("button.add")}
        </Button>
      </FlexBox>
      {alreadyExist && (
        <Typography id="tag-already-exist-label" color="error" fontSize=".9rem">
          {translate("tag.already.exist", newTagName)}
        </Typography>
      )}
    </FlexBox>
  )
}

export const UserTagAdd = connect(
  (state: IRootState): IUserTagAddProps => ({
    tags: state.tag.userTags
  })
)(UserTagAddFn)
